<template>
  <right-banner-template :title="title">
    <div class="contact-content" v-for="(ct, i) in $store.getters['about/finalContact']" :key="i">
      <p class="intro">{{ intro }}</p>
      <div class="contact-row">
        <img @contextmenu.prevent src="../../assets/new-image/company.svg" class="icon">
        <div>
          <p class="title">{{ address }}</p>
          <p>{{ getContactData.address }}</p>
        </div>
      </div>

      <div class="contact-row">
        <img @contextmenu.prevent src="../../assets/new-image/contact-phone.svg" class="icon">
        <div>
          <p class="title">{{ phoneNumber }}</p>
          <p>{{ getContactData.phoneNumber }}</p>
        </div>
      </div>

      <div class="contact-row">
        <img @contextmenu.prevent src="../../assets/new-image/fml-sp.svg" class="icon">
        <div>
          <p class="title">Tư vấn tuyển sinh</p>
          <p> +84 906 787 350 </p>
        </div>
      </div>

      <div class="contact-row">
        <img @contextmenu.prevent src="../../assets/new-image/ml-sp.svg" class="icon">
        <div>
          <p class="title">Tư vấn dịch vụ huấn luyện đào tạo</p>
          <p> +84 819 168 855</p>
        </div>
      </div>
      <!-- <p class="branch">{{ ct.branch }}</p>
      <p><strong>{{ $store.getters['about/finalContactHeader1'] }}: </strong><span>{{ ct.address }}</span></p>
      <p><strong>{{ $store.getters['about/finalContactHeader2'] }}: </strong><span>{{ ct.phoneNum }}</span></p>
      <p><strong>Fax: </strong><span>{{ ct.fax }}</span></p>
      <p id="last"><strong>Website: </strong><a :href="website">{{ ct.website }}</a></p> -->
    </div>
  </right-banner-template>
</template>

<script>
export default {
  props: ['title'],
  computed: {
    getContactData () {
      return this.$store.getters['contact/finalContact']
    },
    intro () {
      if (this.$store.state.lang === 'vn') return 'Cảm ơn các bạn đã quan tâm đến chúng tôi. Nếu có bất kỳ băn khoăn, bạn có thể liên hệ chúng tôi'
      else return 'Thank you for your interest in us. If you have any questions, please feel free to contact us'
    },
    address () {
      if (this.$store.state.lang === 'vn') return 'Địa chỉ'
      else return 'Address'
    },
    phoneNumber () {
      if (this.$store.state.lang === 'vn') return 'Số điện thoại'
      else return 'Phone Number'
    }
  }
}
</script>

<style scoped>
  .branch {
    color: #ff9900;
    font-size: 17px;
  }

  /* .contact-content p {
    margin: 10px 0px;
  } */

  p a {
    color: #006fa9;
    text-decoration: none;
    transition: color 0.2s ease;
  }

  p a:hover {
    color: #d23a3a;
  }

  #last {
    margin-bottom: 40px;
  }

  .intro {
    margin: 20px 0px;
    color: rgb(107 114 128);
  }

  .contact-row {
    display: flex;
    margin-bottom: 40px;
  }

  .contact-row .title {
    font-weight: 600;
    margin-bottom: 5px;
    font-size: 20px;
  }

  .icon {
    padding: 20px;
    background-color: #60a5fa33;
    color: white;
    margin-right: 20px;
  }
</style>
